// import logo from "../assets/logo.png";
import logo from "../assets/matching-master-icon.png";

export default function Header() {
  return (
    <header>
      <nav class=" border-gray-200 px-4 lg:px-6 py-2.5 bg-[#E79014]">
        <div class="flex flex-wrap justify-between items-center mx-auto max-w-screen-xl">
          <a href="#" class="flex items-center">
            <img src={logo} class="mr-3 h-6 sm:h-9" alt="Flowbite Logo" />
            <span class="self-center text-xl font-semibold whitespace-nowrap text-white">
              Matching Master
            </span>
          </a>
          <div class="flex items-center lg:order-2">
            <p className="text-white mr-4">+92 312 4422229</p>
            <p className="text-white mr-4">info@thekaizenglobal.com</p>
            <a
              href="https://play.google.com/store/apps/details?id=com.aiwriter&pcampaignid=web_share"
              class="text-white focus:ring-4 bg-gray-950 font-medium rounded-lg text-sm px-4 lg:px-5 py-2 lg:py-2.5 mr-2 hover:bg-gray-700 focus:outline-none focus:ring-gray-800"
            >
              Download Now
            </a>
          </div>
        </div>
      </nav>
    </header>
  );
}
